import React from "react";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import Slideshow from "../../components/slideshow";
import '../../styles/page.css'

import Banner from '../../images/homepage/titel_2025.png'
import Blutdruck from '../../images/homepage/Slider_Blutdruck.jpg'
import Impfen from '../../images/homepage/Impfen_3_2025.jpg'
import Xund from '../../images/homepage/Slider_Xund.jpeg'
import Influenza from  '../../images/homepage/Slider_Influenza.jpeg'
import Lauf from '../../images/homepage/Laufevent.jpeg'
import sliderA1 from '../../images/homepage/sliderA1.jpeg'
import sliderA2 from '../../images/homepage/sliderA2.jpeg'
import Sliderteamabsage from '../../images/homepage/Slider_terminabsage.jpeg'
import Sliderteamnew from '../../images/homepage/sliderteamphoto9660.jpg'
import teamphoto from '../../images/homepage/WEB-HerzdoktorSebald2026-058.jpg'
import dotoresse from '../../images/homepage/dotoresse.jpeg'


import { FaCalendarAlt } from "react-icons/fa";
import { FiRefreshCw } from "react-icons/fi";
import { GrDocumentText } from "react-icons/gr";
import { FaPhoneAlt } from "react-icons/fa";






const ActionCard = ({
    icon,
    title,
    subtitle,
    description,
    buttonText,
    link
  }) => {
    return (
      <div className="action-card">
        <div>
            <div className="action-card-header">
                <div className="action-card-icon">
                {icon}
                </div>

                <div>
                <h3 className="action-card-title">{title}</h3>

                <p className="action-card-subtitle">
                    {subtitle}
                </p>
                </div>
            </div>

            <p className="action-card-description">
                {description}
            </p>
        </div>
            
        <button className="action-card-button" onClick={() => window.location.href = link}>
          {buttonText}
          <span>›</span>
        </button>
      </div>
    );
  };



const HomePage = () => {
    return (
        <main> 
            <Header image={Banner} className="homepage-header"/>
            <section className="content-section">
                <Navbar />

                <div className="page-container">
                    {/* Main page content */}
                    <h1> Ordination mit Herz <br /> <span style={{"color":"rgb(172, 17, 17)"}}>für Innere Medizin und Kardiologie  </span> </h1> 
                    
                    <div class="termin-absage-info-box">
                        <h2> Wichtiger Hinweis zu Terminabsagen </h2>
                        <p>
                        Sollten Sie einen vereinbarten Termin nicht wahrnehmen können, ersuchen wir Sie, diesen <strong> mindestens 24 Stunden vorher abzusagen. </strong>
                        Bei Nichterscheinen ohne rechtzeitige Absage müssen wir Ihnen <strong> € 100,- Ausfallhonorar </strong> in Rechnung stellen.
                        Wir danken für Ihr Verständnis und dafür, dass Sie damit anderen Patientinnen und Patienten die Möglichkeit geben, den Termin zu nutzen.
                        </p>
                    </div>
        

                    <div className="action-cards-grid">
                        <ActionCard
                            icon={<FaCalendarAlt />}
                            title="Termin buchen"
                            subtitle="Für neue Patienten"
                            description="Wartezeiten auf Ersttermine können derzeit länger sein. Telefonisch geht es aktuell nicht schneller als online."
                            buttonText="Termin"
                            link="/homepage/#/termine"
                        />

                        <ActionCard
                            icon={<FiRefreshCw />}
                            title="Kontaktformular"
                            subtitle="Für allgemeine organisatorische Anliegen"
                            description="Für organisatorische Fragen, Befunde, Überweisungen oder sonstige Anliegen. Wir melden uns zeitnah bei Ihnen."
                            buttonText="Kontaktformular"
                            link="/homepage/#/kontakt/terminanfrage"
                        />

                        <ActionCard
                            icon={<GrDocumentText />}
                            title="Rezept bestellen"
                            subtitle="Für bestehende Patienten"
                            description="Bekannte Dauermedikation einfach online anfragen."
                            buttonText="Rezept"
                            link="/homepage/#/kontakt/rezeptbestellung"
                        />

                        <ActionCard
                            icon={<FaPhoneAlt />}
                            title="Rückruf anfordern"
                            subtitle="Für sonstige Anliegen"
                            description="Wenn Ihr Anliegen nicht online gelöst werden kann, rufen wir Sie gerne zurück. Meist am Nachmittag."
                            buttonText="Anruf"
                            link="/homepage/#/kontakt/terminanfrage"
                        />
                    </div>

                    <div class="contact-notice">
                        <h2>
                            Für weitere Anliegen nutzen sie bitte unser
                            <a href="/homepage/#/kontakt/terminanfrage"> Kontaktformular</a>
                        </h2>

                        <p>
                            <strong>Bitte beachten Sie: </strong>
                            Aus rechtlichen Gründen beantworten wir keine medizinischen Anfragen
                            per elektronischen Schriftverkehr. Für medizinische Fragen oder
                            Befundbesprechungen vereinbaren Sie bitte einen Termin.
                        </p>
                    </div>

                    <div className="slideshow-wrapper">
                        <Slideshow images={[dotoresse, teamphoto, Sliderteamnew, Sliderteamabsage, sliderA1, sliderA2, Lauf, Xund, Influenza, Impfen, Blutdruck]} />
                    </div>
                    
                    
                    <section class="practice-section">
                        <h1>Unsere Ordination</h1>

                        <p>
                            Werte Patientinnen und Patienten,
                        </p>

                        <p>
                            in unserer Ordination bieten wir
                            <strong> allgemeininternistische und kardiologische Untersuchungen </strong>
                            sowie Vorsorgeuntersuchungen an. Hier finden sie
                            <a href="/homepage//#/leistungen"> alle Leistungen &gt;</a>
                        </p>

                        <p>
                            Der Schwerpunkt liegt auf der nichtinvasiven kardiologischen Diagnostik.
                            Besonderes Augenmerk legen wir auf die Einbeziehung der psychosomatischen
                            Medizin. Unser Ziel ist eine persönliche Betreuung und eine gute
                            Zusammenarbeit mit den weiterbehandelnden Krankenhäusern, Kolleginnen
                            und Kollegen sowie Fachabteilungen.
                        </p>

                        <h2>Ihr Erstbesuch</h2>

                        <div class="info-item">
                            <span class="plus">+</span>
                            <p>
                                Für Ihren ersten Termin bringen Sie bitte nach Möglichkeit relevante
                                Vorbefunde sowie eine aktuelle Medikamentenliste mit.
                            </p>
                        </div>

                        <div class="info-item">
                            <span class="plus">+</span>
                            <p>
                                Da wir uns für jeden Termin ausreichend Zeit nehmen und laufend auch
                                Ersttermine einplanen, kann es leider zu längeren Wartezeiten kommen.
                                Wir bemühen uns, Termine so verlässlich und fair wie möglich zu vergeben.
                            </p>
                        </div>

                        <div class="info-item">
                            <span class="plus">+</span>
                            <p>
                                Wir empfehlen das freiwillige Tragen einer FFP2-Maske, insbesondere
                                bei viralen oder fieberhaften Infekten oder bei Krankheitsgefühl.
                                So schützen Sie sich und andere Patientinnen und Patienten.
                            </p>
                        </div>

                        <h2>Telefon &amp; Rückruf</h2>

                        <p>
                            Bei hoher Nachfrage kann es telefonisch zu längeren Wartezeiten kommen.
                            Termine sind telefonisch nicht schneller verfügbar als online. Wenn Ihr
                            Anliegen nicht online gelöst werden kann, fordern Sie bitte einen Rückruf an.
                        </p>

                        <p>
                            Weitere Kontaktmöglichkeiten finden Sie unter
                            <a href="/homepage/#/kontakt"> Kontakt &gt;</a>
                        </p>
                    </section>

                </div>

                 {/* Main page content end */}

            </section>
            <Footer />
        </main>
    )
}

export default HomePage;